import { zoomReducerKey } from './ZoomConstants';

// eslint-disable-next-line import/prefer-default-export
export function zoomBranch(state) {
  return state.get(zoomReducerKey);
}
